import { getSecret, getSecretFeatureToggle } from './i18n/secret'
import { CLIENT_TYPES } from '../helpers/const'

export const getCategoryAdSlotConfigs = (category, flyerId, clientType) => country => {
  const advEnabled = getSecretFeatureToggle('AD_MANAGER_CATEGORY_ENABLED')(country)

  if (
    !advEnabled
    || !category
    || !flyerId
    || !Object.values(CLIENT_TYPES).includes(clientType)
  ) return {}

  const cat = category ? category.replace(/(\s)/g, '_').toLowerCase() : ''
  const slotId = getSecret('AD_MANAGER_CATEGORY_SLOT_ID')({ country })
  const slotName = getSecret('AD_MANAGER_CATEGORY_SLOT_NAME')({ country })
  const domNodeId = `s2s-cb-category-${slotId}-${cat}`
  const enabled = advEnabled && slotId && slotName

  if (!enabled) return {}

  const adSlotConfigs = {
    domNodeId,
    sizes: ['fluid'],
    slotId,
    slotName,
    targets: {
      Collection_Banner: category,
      flyer_id: flyerId,
      Client_Type: clientType,
    },
  }
  return adSlotConfigs
}
